import Button from 'components/button';
import React from 'react';
import { Link, useParams } from 'react-router-dom';

import './Unauthorized.scss';

const UnAuthorized = () => {
	let { action } = useParams();
	return (
		<div
			className='d-flex justify-content-center align-items-center page-wrapper
     flex-grow-1 w-100 min-vh-100'
		>
			{!action ? (
				<div className='text-container'>Unauthorized to view this page</div>
			) : (
				<div className='text-container'>Unauthorized for this action</div>
			)}
			<Button className='btn-primary my-2'>
				<Link to='/dashboard' className='go-back-link'>
					Back to Home Page
				</Link>
			</Button>
		</div>
	);
};

export default UnAuthorized;
